<template>
  <div class="login-page">
    <Header />
    <div class="login-form">
      <Card>
        <div class="mb-3 text-center">
          <h2 class="font-size-20 font-weight-700 text-title-color">Login to Pension Keeper</h2>
          <div class="d-flex flex-column align-center justify-center">
            <VProgressCircular indeterminate color="primary" class="my-8" />
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
// Service
import userService from '@/services/user-service/user.service';
// Components
import Card from '@/components/common/Card/Card.vue';
import Header from '@/components/common/Header/Header.vue';
//Text
import { errorLoginText } from '@/text/snackbarsText';
export default {
  name: 'LoginAsAdminPage',
  components: {
    Header,
    Card
  },
  mounted() {
    if (this.$route?.query?.applicationNumber && this.$route?.query?.pw) {
      console.log(this.$route);
      this.form = {
        applicationNumber: this.$route.query.applicationNumber,
        password: this.$route.query.pw
      };
      this.handleLogin();
    } else this.$router.push({ name: 'Login' });
  },
  data() {
    return {
      form: {
        applicationNumber: '',
        password: ''
      }
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    ...mapActions('user', ['logInUser', 'logOutUser']),
    async handleLogin() {
      try {
        this.logOutUser();
        const { application } = await userService.loginUserAsAdmin(this.form);
        if (application?.id) {
          this.logInUser(application);
          this.$router.push({ name: 'Overview' });
        } else {
          this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
          this.$router.push({ name: 'Login' });
        }
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: errorLoginText, color: 'red' });
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
</script>
